import { render, staticRenderFns } from "./FormularioReaproveitar.vue?vue&type=template&id=2ea034d9&scoped=true&"
import script from "./FormularioReaproveitar.vue?vue&type=script&lang=js&"
export * from "./FormularioReaproveitar.vue?vue&type=script&lang=js&"
import style0 from "./FormularioReaproveitar.vue?vue&type=style&index=0&id=2ea034d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ea034d9",
  null
  
)

export default component.exports